import React from "react";
import { useState, useEffect } from "react";
import mondaySdk from "monday-sdk-js";
import "@vibe/core/tokens";
import HomeSection from "../components/home";
import ErrorPage from "../components/errorPage";
import UpdateVersion from "./update/new_version";
import PageLoader from "../components/PageLoader";
import useUser from "../hooks/context/userHook";
import logger from "../lib/logger";
import { useLocation, useNavigate } from "react-router-dom";
import { useCheckUserOnboarding } from "../hooks/api/useCheckUserOnboarding";

const monday = mondaySdk();

/**
 * Maps app feature types to their corresponding routes
 */
const APP_FEATURE_ROUTES: Record<string, string> = {
  AppFeatureItemMenuAction: "/board-item-menu",
  AppFeatureItemBatchAction: "/batch-items-menu",
  AppFeatureBoardView: "/resynchronization",
  AppFeatureBoardColumnExtension: "/add-column",
  AppFeatureDialog: "/boards-dialog",
};

const Home = () => {
  const { userId } = useUser();
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [version, setVersion] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(() => {
    // Check synchronously on mount if there's a pending redirect
    return !!localStorage.getItem("pendingAuthRedirect");
  });
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tourState = searchParams.get("tour") === "true";
  const justAuthorized = searchParams.get("authorized") === "true";

  const { isAuthorized, isLoading, error } = useCheckUserOnboarding(userId);

  monday.execute("valueCreatedForUser");

  // Handle pending auth redirect after OAuth callback
  useEffect(() => {
    const pendingRedirect = localStorage.getItem("pendingAuthRedirect");

    if (pendingRedirect && isAuthorized) {
      localStorage.removeItem("pendingAuthRedirect");
      const route = APP_FEATURE_ROUTES[pendingRedirect];
      if (route) {
        navigate(route, { replace: true });
        return;
      }
    }

    // Only clear redirecting state if auth check is done and no redirect needed
    if (!isLoading) {
      setIsRedirecting(false);
    }
  }, [isAuthorized, isLoading, navigate]);

  useEffect(() => {
    monday.execute("valueCreatedForUser");
    monday
      .get("context")
      .then((res) => {
        let dataVersion = res.data.appVersion.versionData.major;
        //version for force update

        //make the app true
        parseInt(dataVersion) < 27 ? setVersion(false) : setVersion(false);
        res.data.user.isViewOnly ? setIsViewOnly(true) : setIsViewOnly(false);
        let itemidsArray = [];
        res.data.appFeature.type === "AppFeatureItemBatchAction"
          ? (itemidsArray = res.data.selectedPulsesIds)
          : itemidsArray.push(res.data.itemId);

        //handle the array here
      })
      .catch((error) => {
        logger.error(error.message);
      })
      .finally(() => {});
  }, []);

  // Show loader while checking auth or redirecting
  if (isRedirecting || isLoading) {
    return <PageLoader />;
  }

  return (
    <div>
      {isViewOnly ? (
        <div className="flex justify-center items-center h-screen">
          <div className="px-4 py-3 bg-red-100 rounded">
            <span className="block sm:inline">As a viewer, you are unable to use the SIMB.</span>
          </div>
        </div>
      ) : !error ? (
        version ? (
          <UpdateVersion />
        ) : (
          <>
            <HomeSection tourState={tourState} justAuthorized={justAuthorized} />
          </>
        )
      ) : (
        <ErrorPage />
      )}
    </div>
  );
};

export default Home;
